/**
 * Core Concepts docs page — fundamental building blocks of the platform.
 */

import { createFileRoute } from "@tanstack/react-router";
import { DocsPage } from "@/components/docs/docs-page";
import { coreConceptsContent } from "@/constants/docs/core-concepts";

export const Route = createFileRoute("/docs/core-concepts")({
	component: CoreConceptsPage,
});

function CoreConceptsPage() {
	return <DocsPage title="Core Concepts" content={coreConceptsContent} />;
}
